//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { theme } from '@bvengineering/unison-core';
import React, { useState } from 'react';
import { ActionButton } from 'unison';

import PartialCuid from '@models/PartialCuid';
import makeAngularReactControllerWithScope from '@react-bridge/angular-react-widget-with-scope';

import { UiaReportAiContentModal } from 'app/bulk-actions/uia-bulk-actions/UiaReportAiContentModal';

interface UniversalImageActionsReportButtonProps {
  cuid: PartialCuid;
  onReportError: () => void;
  onReportSuccess: () => void;
}

export const UniversalImageActionsReportButton = ({
  cuid,
  onReportError,
  onReportSuccess,
}: UniversalImageActionsReportButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <ActionButton
        iconName='bullhorn'
        label='Report Content'
        onClick={() => setIsOpen(true)}
      />
      <UiaReportAiContentModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onReportError={onReportError}
        onReportSuccess={onReportSuccess}
        selectedItems={[{ cuid }]}
        zIndexOverlayOverride={theme.zindex.modal}
      />
    </>
  );
};

angular.module('curalate').component('universalImageActionsReportButton', {
  bindings: {
    cuid: '<',
    onReportError: '&',
    onReportSuccess: '&',
  },
  controller: makeAngularReactControllerWithScope(
    ({ $ctrl }: { $ctrl: UniversalImageActionsReportButtonProps }) => (
      <UniversalImageActionsReportButton {...$ctrl} />
    ),
  ),
});
